export function replaceTemplateVariablesWithIndices(
  setSimpleToasts: (toast: { type: string; message: string; show: boolean }) => void,
  text?: string,
) {
  if (!text) {
    setSimpleToasts({
      type: 'warning',
      message: 'There is no WhatsApp template to copy ',
      show: true,
    });
    return;
  }

  const seen = new Map<string, number>();
  let counter = 1;

  const allowDuplicateIndexing = process.env.REACT_APP_NO_DUPLICATE_INDEXING === 'true';

  const replacedText = text.replace(
    /{{\s*([\w.]+)\s*}}/g,
    (_, variable: string): string => {
      if (allowDuplicateIndexing) {
        return `{{${counter++}}}`;
      } else {
        if (!seen.has(variable)) {
          seen.set(variable, counter++);
        }
        return `{{${seen.get(variable)}}}`;
      }
    },
  );

  navigator.clipboard.writeText(replacedText);
  setSimpleToasts({
    type: 'success',
    message: 'WhatsApp template copied successfully',
    show: true,
  });
}

export const copyWhatsappTemplate = (
  setSimpleToasts: (toast: { type: string; message: string; show: boolean }) => void,
  text?: string,
) => {
  if (!text) {
    setSimpleToasts({
      type: 'warning',
      message: 'There is no WhatsApp template Id to copy ',
      show: true,
    });
    return;
  }

  navigator.clipboard.writeText(text);

  setSimpleToasts?.({
    type: 'success',
    message: `Copied WhatsApp template Id to clipboard`,
    show: true,
  });
};
